import React, { Component, Suspense } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';               //Routing component - to display the corresponding containers
import GLOBAL_CONFIG from '../config/config';		            //Global Settings that contains URL etc
//import AsyncComponent from '../../hoc/AsyncComponent';       //Async loading of components    
import MetaHeader from '../components/Content/MetaHeader/MetaHeader';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';
import Banner from '../components/Layout/Banner';
import NavigationContent from '../components/Content/NavigationContent/NavigationContent';

/*
    All website pages as container
*/
import Home from '../pages/Home/Home';                            //Home page content
import Holding from '../pages/Holding/Holding';                   //Holding page content
import PrizeAlle from '../pages/Prize/PrizeAlle';                         //Prize page content
import Participation from '../pages/Participation/Participation'; //Parcipation page content
import ThankYou from '../pages/ThankYou/ThankYou';                //Thank you page content
import Faq from '../pages/Faq/Faq';                               //FAQ page content
import End from '../pages/End/End';                               //End Campaign page content
import Terms from '../pages/Terms/Terms';                         //Terms and conditions page content
import Error from '../pages/Error/Error';                         //Error page content  
import Cookie from '../pages/Cookie/Cookie';                      //Cookie page content
import Iban from '../pages/Iban/iban';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import Transfert from '../pages/Transfert/Transfert';
import HomeNasher from '../pages/Home/HomeNasher';
import Prize from '../pages/Prize/Prize';
import WheelSpin from '../pages/WheelSpin/WheelSpin';
import ibanConfirm from '../pages/Iban/ibanConfirm';
// import HomeNasher from '../pages/Home/Home';

/* Lazy loading of component */
/*
const Home          = React.lazy(() => import('../Home/Home'));                     //Home page content
const Holding       = React.lazy(() => import('../Holding/Holding'));               //Holding page content                    
const Prize         = React.lazy(() => import('../Prize/Prize'));                   //Prize page content
const Participation = React.lazy(() => import('../Participation/Participation'));   //Parcipation page content
const ThankYou      = React.lazy(() => import('../ThankYou/ThankYou'));             //Thank you page content
const Faq           = React.lazy(() => import('../Faq/Faq'));                       //FAQ page content
const End           = React.lazy(() => import('../End/End'));                       //End Campaign page content
const Terms         = React.lazy(() => import('../Terms/Terms'));                   //Terms and conditions page content
const Error         = React.lazy(() => import('../Error/Error'));                   //Error page content 
const Cookie        = React.lazy(() => import('../Cookie/Cookie'));                 //Cookie page content
*/

// Use layout as the main wrapper for our app
class Layout extends Component {

    banner = () => {
        if (this.props.campaignStatus === 'main' || this.props.campaignStatus === 'holding' || this.props.campaignStatus === 'end' ) {
            if (this.props.location.pathname === '/' || this.props.location.pathname === '/faq' ) { // Use this.props.location.pathname instead
                console.log('waersfgrdhg');
                return (
                    <Banner campaignStatus={this.props.campaignStatus} promotionCampaign={this.props.promotionCampaign} />
                );
            }
        }
    }

    componentDidMount(){
    }
    render() {
        //Campaign is assign
        let RouteRender = null

        if (this.props.campaign === true) {
            console.log('this.props.campaign', this.props.campaign);

            //Routing check for 
            // if (this.props.promotionCampaign !== 'alle') {

            if (this.props.campaignStatus === 'holding') {
                // alert('huhu')
                RouteRender = (
                    <Switch>
                        <Route path="/" exact component={Holding} />

                        <Route path={GLOBAL_CONFIG.Route.cookie} exact component={Cookie} />
                        <Route path={GLOBAL_CONFIG.Route.terms} exact component={Terms} />
                        <Route path={GLOBAL_CONFIG.Route.faq} exact component={()=> <Faq promotionCampaign={this.props.promotionCampaign} />} />
                        <Route component={Error} />

        
                    </Switch>
                );

            
            } else if (this.props.campaignStatus === 'end') {
                // alert('huhu')
                RouteRender = (
                    <Switch>
                        <Route path="/" exact component={End} />
                        
                        <Route path={GLOBAL_CONFIG.Route.cookie} exact component={Cookie} />
                        <Route path={GLOBAL_CONFIG.Route.terms} exact component={Terms} />
                        <Route path={GLOBAL_CONFIG.Route.faq} exact component={()=> <Faq promotionCampaign={this.props.promotionCampaign} />} />
                        <Route path={GLOBAL_CONFIG.Route.iban} exact component={Iban} />
                        <Route path={GLOBAL_CONFIG.Route.ibanConfirm} exact component={ibanConfirm} />
                        <Route component={Error} />

        
                    </Switch>
                );

            } if (this.props.campaignStatus === 'main') {
                // alert('test')
                RouteRender = (
                    <Switch>

                        <Route path={GLOBAL_CONFIG.Route.spin} exact component={WheelSpin} /> 


                        <Route
                            path={GLOBAL_CONFIG.Route.home}
                            exact
                            component={() =>
                                this.props.promotionCampaign === 'alle' ? (
                                    <HomeNasher prizeAvailable={this.props.prizeAvailable} />
                                ) : (
                                    <Home />
                                )
                            }
                        />
                        

                        <Route
                            path={GLOBAL_CONFIG.Route.participation}
                            exact
                            component={() =>
                                this.props.promotionCampaign === 'alle' ? (
                                    <HomeNasher />
                                ) : (
                                    <Participation promotionCampaign={this.props.promotionCampaign} />
                                )
                            }
                        />


                        {/* <Route path={GLOBAL_CONFIG.Route.participation} exact component={() => <Participation prizeAvailable={this.props.prizeAvailable} />} /> */}
                        
                        
                        
                        <Route path={GLOBAL_CONFIG.Route.gift} exact component={Transfert} />
                        <Route path={GLOBAL_CONFIG.Route.thankyou} exact component={ThankYou}  />
                        <Route path={GLOBAL_CONFIG.Route.faq} exact component={()=> <Faq promotionCampaign={this.props.promotionCampaign} />} />
                        <Route path={GLOBAL_CONFIG.Route.terms} exact component={Terms} />
                        <Route path={GLOBAL_CONFIG.Route.cookie} exact component={Cookie} />
                        <Route path={GLOBAL_CONFIG.Route.iban} exact component={Iban} />
                        <Route path={GLOBAL_CONFIG.Route.ibanConfirm} exact component={ibanConfirm} />
                        <Route component={Error} />
                    </Switch>
                );


            } 
        } else {
            console.log('test other')
            RouteRender = (
                <Switch>
                    <Route path="/" exact component={Holding} />
                    
                </Switch>
            );
        }

        //Master page - that contains all routes for the different pages / containers
        return (
            <>
                <MetaHeader promotionCampaign={this.props.promotionCampaign} />
                <Header />
                <main className="main-content">
                    {this.banner()}
                    {RouteRender}
                </main>
                <Footer />
            </>
        );
    }
}

export default withRouter(Layout);